import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Link, useHistory } from 'react-router-dom';
import { Typography, Button } from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { FlexDiv, WideBox } from '../../styles/styles';
import { CustomTable, FilterPlaceholder } from '../../common/CustomTable';
import permissionCheck from '../../util/PermCheck';

const columns = [
  {
    Header: 'Transaction Type',
    accessor: 'TranType',
    Filter: FilterPlaceholder,
    width: 70,
  },
  {
    Header: 'Name',
    accessor: 'PaymentTypeName',
  },
];

const PaymentTypes = () => {
  const { authStore } = useRootStore();
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const permitted = permissionCheck('PAYMENTTYPE_M');
  const fetchPaymentTypes = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/payment-types`,
      );
      setPaymentTypes(data);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    const initialize = async () => {
      await fetchPaymentTypes();

      setLoading(false);
    };
    initialize();
  }, []);
  if (isLoading) return <Spinner />;
  return (
    <Observer
      render={() => {
        return (
          <FlexDiv>
            <WideBox style={{ maxWidth: '1200px', width: '98%' }}>
              <CustomTable
                data={paymentTypes}
                columns={columns}
                minRows={1}
                trClassName="react-table-hover-row"
                tableHeader={
                  <Typography variant="h2">Payment Types</Typography>
                }
                containerStyle={{ padding: '0 2rem' }}
              />
            </WideBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default PaymentTypes;
